<template src="../templates/normal_fcont_178.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import FuncSearchRecommendLinkBtn from '../components/FuncSearchRecommendLinkBtn'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadColorioNenga from '../components/AppDownloadColorioNenga'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '178',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,FuncSearchRecommendLinkBtn,
    FuncSearchGalleryQR,
    ReleaseDateForArticle,
    AppDownloadCreative,AppDownloadColorioNenga
  },

  computed: {
    fcontId: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1);
    },
  },
  methods: {
    trackGa4AppDownloadEvent: function () {
      this.$gtag.event("app_download", {
        app_name: "Photo Plus",
        location_id: "article",
        article_no: this.fcontId,
        site_id: "gallery"
      });
    },
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['178-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['178-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
div.collabo_profile {
    border: solid 1px #5a5a5a;
    border-radius: 10px;
    padding: 3px 8px;
    margin-top: 10px;
}

img.img-square{
  width: 560px;
} 


</style>

